import { TipoPersona } from "../../enums/TipoPersona";
import { Cliente } from "./Cliente";

export class ModificacionEstadoDTO{
    id: string;
    estadoFinal: number;
    motivoRechazo: string;
    modificacionesCuentas: ModificacionEstadoDTO[]
}